import React from "react";

import { setLanguageCookie } from "@services/cookie.service";

import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { getLabel } from "@components/General/LanguageSelector/partials/label.component";

import { useLanguageSelectorPath } from "../../languageSelector.helper";

type Props = {
    language: Language;
    isCurrent: boolean;
    variant?: string;
};

const LanguageListItem = ({ language, isCurrent, variant }: Props) => {
    const languageUrl = useLanguageSelectorPath(language.path);

    if (isCurrent) {
        return <span>{getLabel(language, variant)}</span>;
    } else {
        return (
            <a
                className={isCurrent ? "current" : ""}
                href={languageUrl}
                onClick={() => setLanguageCookie(language.languageCode)}
            >
                {getLabel(language, variant)}
            </a>
        );
    }
};

export { LanguageListItem };
